import React, { Component } from 'react';
import deleteIcon from './images/delete.svg';
import downIcon from './images/down.svg';
import upIcon from './images/up.svg';
import styles from './index.less';

export default class SelectList extends Component {
  renderList = selectedNum => {
    const { selectedRows = [] } = this.props;
    return (
      <div className="list-wrap">
        {selectedRows.map((item, index) => {
          if (index === 0) {
            return this.renderFirst(item, index, selectedNum);
          }
          return this.renderCommon(item, index, selectedNum);
        })}
      </div>
    );
  };

  renderCommon = (record, index, selectedNum) => {
    const { downItem, deleteItem, upItem } = this.props;
    return (
      <div className="common-item">
        <div className="list-item-title">
          <div>{record.title}</div>
          <img src={record.coverPicFileUrl} alt="" />
        </div>
        <div className="action">
          <span className="mask" />
          <img className="up-icon" src={upIcon} onClick={() => upItem(record, index)} alt="" />
          {index !== selectedNum - 1 && (
            <img
              className="down-icon"
              src={downIcon}
              onClick={() => downItem(record, index)}
              alt=""
            />
          )}
          <img className="delete-icon" src={deleteIcon} onClick={() => deleteItem(record)} alt="" />
        </div>
      </div>
    );
  };

  renderFirst = (record, index, selectedNum) => {
    const { downItem, deleteItem } = this.props;
    return (
      <div className="common-item first-item">
        <div className="cover">
          <img src={record.coverPicFileUrl} alt="" />
          <>
            <span className="mask" />
            <span className="text">{record.title}</span>
          </>
        </div>
        <div className="action">
          <span className="mask" />
          {selectedNum > 1 && (
            <img
              className="down-icon"
              src={downIcon}
              onClick={() => downItem(record, index)}
              alt=""
            />
          )}
          <img className="delete-icon" src={deleteIcon} onClick={() => deleteItem(record)} alt="" />
        </div>
      </div>
    );
  };

  renderTips = tips => {
    return <div className="singleMost"> {tips}</div>;
  };

  render() {
    const { selectedRows = [], tips } = this.props;
    const selectedNum = selectedRows.length;
    return (
      <div className={styles.root}>
        <section className="select-list">
          <div className="title">
            已选文章({selectedNum}){this.renderTips(tips)}
          </div>
          {selectedNum === 0 ? (
            <div className="no-data">请在右侧列表选择资讯内容</div>
          ) : (
            this.renderList(selectedNum)
          )}
        </section>
      </div>
    );
  }
}
